import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { TradesScreen } from "@/features/leagues/trades/TradesScreen";

type TradeSearch = {
  requestedPickId?: string | undefined;
};

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/trades")({
  validateSearch: (search: Record<string, unknown>): TradeSearch => ({
    requestedPickId:
      typeof search.requestedPickId === "string" ? search.requestedPickId : undefined,
  }),
  component: LeagueTradesPage,
});

function LeagueTradesPage() {
  const { leagueId } = Route.useParams();
  const { requestedPickId } = Route.useSearch();

  return (
    <TradesScreen
      leagueId={leagueId as Id<"leagues">}
      initialRequestedPickId={requestedPickId as Id<"draftPicks"> | undefined}
    />
  );
}
